import { Grid } from 'semantic-ui-react';
export default Grid;